<template>
  <a-range-picker
    v-bind="options"
    :defaultValue="defaultValue"
    :disabled="disabled"
    :style="{ width: width + 'px', ...styleObj }"
    :placeholder="placeholder"
    allowClear
    @change="onChange"
  />
</template>

<script>
export default {
  name: 'DateSelect',
  props: {
    defaultValue: {
      type: [Number, String, Array],
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: Array,
      default() {
        return ['请选择开始日期', '请选择结束日期']
      }
    },
    styleObj: {
      type: Object,
      default() {
        return {}
      }
    },
    width: {
      type: Number,
      default: 300
    },
    // 附加配置项
    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    onChange(e) {
      this.$emit('change', e)
    }
  }
}
</script>
